import { TSessionBlockWithReasons } from '@monorepo/types';
import { ModifiersZTableModel } from '@monorepo/ui';
import moment from 'moment';

export const PRODUCTION_HOUR_TO_REASON_MAP_TABLE_MODEL = {
  createTable: (data: TSessionBlockWithReasons[]) => {
    return ModifiersZTableModel.createTableModel(
      data,
      {
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'Session Block',
          },
          {
            type: 'TEXT_CELL',
            text: 'Hour',
          },
          {
            type: 'TEXT_CELL',
            text: 'Sub Type',
          },
          {
            type: 'TEXT_CELL',
            text: 'Reasons',
          },
          {
            type: 'TEXT_CELL',
            text: 'Last Updated At',
          },
          {
            type: 'TEXT_CELL',
            text: 'Action',
          },
        ],
      },
      (item) => {
        const displayName = ` ${item.start_time} - ${item.end_time}`;

        return {
          type: 'ROW',
          rowItem: item,

          cells: [
            {
              type: 'TEXT_CELL',
              text: item.session_block,
            },
            {
              type: 'TEXT_CELL',
              text: displayName,
            },
            {
              type: 'TEXT_CELL',
              text: item.sub_type || '--',
            },
            {
              type: 'TEXT_CELL',
              text: item.reasons.length > 0 && item.sub_type === 'WORK' ? item.reasons[0] : '--',
              ...(item.reasons.length > 1 && item.sub_type === 'WORK'
                ? {
                    tag: {
                      tagContent: item.reasons.length > 1 ? `+${item.reasons.length - 1} more` : '',
                      tagBgColor: 'BLUE',
                      showTooltipEvent: 'click',
                      ...(item.reasons.length > 1 ? { tagTooltipContent: item.reasons.join(', ') } : {}),
                    },
                  }
                : {}),
            },
            {
              type: 'TEXT_CELL',
              text:
                item.updatedAt && item.sub_type === 'WORK'
                  ? moment(item.updatedAt).format('DD/MM/YYYY HH:mm:ss')
                  : '--',
            },
            {
              type: 'ACTION_CELL',
              actionType: 'EDIT',
              asIcon: true,
              iconName: 'pencil',
              isDisabled: item.sub_type !== 'WORK',
            },
          ],
        };
      },
    );
  },
};
